module.exports = __webpack_public_path__ + "img/dia_dos_pais.3b6663c3.svg";